import { getNeutralColors } from './utils/getPaletteColors';

export default {
  background: {
    default: getNeutralColors('white'),
    tint1: getNeutralColors('grisClaro'),
    tint2: getNeutralColors('grisMedio'),
    tint3: getNeutralColors('grisMedioOscuro'),
    overlay: getNeutralColors('overlay')
  },

  border: {
    default: getNeutralColors('grisMedioClaro'),
    optional: getNeutralColors('grisMedio')
  },

  text: {
    default: getNeutralColors('black')
  }
};
